import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    flexGrow: 1,
    padding: '1rem 0.5rem 1rem 0',
    '&:hover': {
      '& .delete': { display: 'block' },
      '& .edit': { display: 'block' }
    },
    [theme.breakpoints.down('sm')]: {
      '& .delete': { display: 'block' },
      '& .edit': { display: 'block' }
    },

    '& .delete': {
      position: 'absolute',
      top: '1rem',
      right: '0',
      cursor: 'pointer',
      fontSize: theme.size.sm,
      color: '#323436',
      display: 'none',
      '& svg': {
        height: '0.75rem',
        width: '0.75rem'
      }
    },

    '& .edit': {
      position: 'absolute',
      top: '2.25rem',
      right: '0',
      cursor: 'pointer',
      fontSize: theme.size.sm,
      color: '#323436',
      display: 'none',
      '& svg': {
        height: '0.75rem',
        width: '0.75rem'
      }
    },

    '&:not(:last-child)': {
      borderBottom: 'solid 1px lightgrey'
    }
  },

  content: {
    fontSize: theme.size.base,
    color: '#1F1F1F',
    width: '100%',
    whiteSpace: 'pre-wrap'
  },

  infoSection: {
    display: 'flex',
    flexDirection: 'column'
  },

  info: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '8px',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  author: {
    marginRight: '4px',
    paddingRight: '4px',
    borderRight: '2px solid lightgrey',

    '& span': {}
  },

  expand: {
    marginTop: '16px',
    cursor: 'pointer',
    fontSize: theme.size.sm,
    color: '#8F8F8F',
    textDecoration: 'none'
  },

  modalNote: {
    marginTop: '0.5rem'
  }
}))

export default useStyles
